import React from 'react';
import  DATA  from "../Data";
import { NavLink } from "react-router-dom";

const Product = () => {
    
    const cardItem = (item) => {
        return(
        <div className="card my-5 py-4" key={item.id} style={{width: "20rem"}}>
            <img className='card-img-top' src={item.images} alt='myimg' height={300} />
            
            <div className="card-body text-center">
                <h5 className="card-title font-weight-bold">{item.title}</h5>
                {/* <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                <p className='lead font-weight-bold'>₹{item.price}</p>
                <NavLink to={`/product/${item.id}`} className="btn btn-outline-primary font-weight-bold">Buy Now</NavLink>
            </div> 
        </div>
        );
    }
        
    return (
        <div>
            <div className='container py-5'>
                <div className='row justify-content-around'>
                    <div className='col-12 text-center'>
                        <h1>Product</h1>
                        <hr />
                    </div>
                </div>
            </div>

            <div className='container'>
                <div className='row justify-content-around'>
                    {DATA.map(cardItem)}
                </div>
            </div>
        </div>
    );
}

export default Product













